/**
 * @fileoverview Game page — wraps the Konva canvas container.
 */

import { ToddlerGame } from '../ToddlerGame.js';
import { BasePage } from './BasePage.js';
import { currentLang } from '../../i18n/lang.js';

export class GamePage extends BasePage {
    private game: ToddlerGame;

    constructor(game: ToddlerGame) {
        super('container');
        this.game = game;
    }

    private static readonly DEVICE_NOTES: Record<string, string> = {
        en: 'This app can be played on most old tablets and phones.',
        de: 'Diese App l\u00e4uft auf den meisten \u00e4lteren Tablets und Handys.',
        es: 'Esta aplicaci\u00f3n funciona en la mayor\u00eda de tablets y m\u00f3viles antiguos.',
        fr: 'Cette application fonctionne sur la plupart des vieilles tablettes et t\u00e9l\u00e9phones.',
        pt: 'Este aplicativo funciona na maioria dos tablets e celulares antigos.',
    };

    protected async render(): Promise<void> {
        const el = document.getElementById('deviceNote');
        if (el) el.textContent = GamePage.DEVICE_NOTES[currentLang] ?? GamePage.DEVICE_NOTES.en;
        this.game.isPaused = false;
        try {
            this.game.audioSystem?.getBackgroundMusic().play();
        } catch (e) {}
    }

    override mount(_params?: Record<string, string> | null): void {
        super.mount();
        // container uses no hidden class — just remove it from others
        // super.mount() already does that, but container itself may not need .hidden removed
        // ensure it's visible
        this.el.classList.remove('hidden');
    }

    /** Called when navigating away from the game page. */
    pause(): void {
        this.game.isPaused = true;
        try {
            this.game.audioSystem?.getBackgroundMusic().pause();
        } catch (e) {}
    }
}
